export default "__VITE_ASSET__Fc1OfAkj__"